import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../../lib/business";

export default function FloatingCTA() {
  return (
    <div
      data-testid="floating-cta-wrapper"
      className="sm:hidden fixed bottom-0 inset-x-0 z-40 bg-zinc-950/90 backdrop-blur-xl border-t border-white/10 px-4 py-3 shadow-[0_-8px_32px_rgba(225,6,0,0.2)]"
    >
      <a
        href={PHONE_TEL}
        data-testid="floating-call-now"
        className="w-full inline-flex items-center justify-center gap-2 bg-[#E10600] hover:bg-[#FF2D1A] text-white font-display uppercase tracking-wide font-bold px-5 py-4 rounded-full transition-colors"
      >
        <Phone className="w-5 h-5" />
        Call/Text Now: {PHONE_DISPLAY}
      </a>
    </div>
  );
}
